import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { ApiError } from "@/lib/api/unwrap";

/** Inline loading spinner with an accessible label. */
export function LoadingBlock() {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center gap-2 py-8 text-muted-foreground"
      role="status"
    >
      <Loader2 className="size-5 animate-spin" aria-hidden />
      {t("questionnaire.loading")}
    </div>
  );
}

/** Inline error message. Surfaces a subscription hint on a 403. */
export function ErrorBlock({ error }: { error: unknown }) {
  const { t } = useTranslation();
  const apiError = error as ApiError | null;
  const message =
    apiError?.status === 403
      ? t("questionnaire.subscriptionRequired")
      : (apiError?.detail ?? t("questionnaire.loadError"));
  return (
    <p className="py-8 text-sm font-medium text-destructive" role="alert">
      {message}
    </p>
  );
}
